import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SavedFilterEntity } from '../../domain/entities/saved-filter.entity';
import { SavedFiltersApi } from '../api/saved-filters.api';
import { SavedFiltersMapper } from '../mappers/saved-filters.mapper';

@Injectable({ providedIn: 'root' })
export class SavedFiltersRepository {
  private readonly _api = inject(SavedFiltersApi);
  private readonly _mapper = inject(SavedFiltersMapper);

  public getSavedFilters(): Observable<SavedFilterEntity[]> {
    return this._api.getSavedFilters().pipe(map((dtos) => this._mapper.toDomainArray(dtos)));
  }
}
